import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import and from 'ember-truth-helpers/helpers/and';
import not from 'ember-truth-helpers/helpers/not';
import BoxItem from 'volta/components/box-item';
import classNames from 'volta/helpers/class-names';
interface BvChoiceBlocksInputArgs {
    checked: boolean;
    disabled?: boolean;
    class?: string;
    testName?: string;
    onChange?: (e: MouseEvent) => void;
    onFocus?: (e: FocusEvent) => void;
    onBlur?: (e: FocusEvent) => void;
    onHover?: (e: MouseEvent) => void;
    onMouseEnter?: (e: MouseEvent) => void;
    onMouseLeave?: (e: MouseEvent) => void;
}
export interface BvChoiceBlocksInputSignature {
    Args: BvChoiceBlocksInputArgs;
    Blocks: {
        default: [{
                checked: BvChoiceBlocksInputArgs['checked'];
                disabled?: boolean;
                onChange: (e: MouseEvent) => void;
            }];
    };
    Element: HTMLElement;
}
export default class BvChoiceBlocksInputComponent extends Component<BvChoiceBlocksInputSignature> {
    @tracked
    focused: boolean = false;
    @action
    onChange(e: MouseEvent) {
        if (this.args.onChange && !this.args.disabled) {
            this.args.onChange(e);
        }
    }
    @action
    onFocus(e: FocusEvent) {
        this.focused = true;
        if (this.args.onFocus) {
            this.args.onFocus(e);
        }
    }
    @action
    onBlur(e: FocusEvent) {
        this.focused = false;
        if (this.args.onBlur) {
            this.args.onBlur(e);
        }
    }
    static{
        template_fd9b2463e5f141cfb5666b64daa1f11a(`
    {{#let (and (not @disabled) @checked) (and (not @disabled) this.focused) as |selected focused|}}
      <BoxItem
        @disabled={{@disabled}}
        @selected={{selected}}
        @tagName='label'
        class={{classNames
          'bv-choice-block-item'
          (if selected 'bv-choice-block-item--checked')
          (if focused 'bv-choice-block-item--focused')
          (if @disabled 'bv-choice-block-item--disabled')
          @class
        }}
        data-test-choice-block-input={{@testName}}
        ...attributes
        {{on 'mouseover' (optional @onHover)}}
        {{on 'mouseenter' (optional @onMouseEnter)}}
        {{on 'mouseleave' (optional @onMouseLeave)}}
      >
        {{! template-lint-disable require-input-label }}
        <input
          type='radio'
          class='bv-choice-block-item__input'
          aria-checked={{@checked}}
          checked={{@checked}}
          disabled={{@disabled}}
          {{on 'click' this.onChange}}
          {{on 'focus' this.onFocus}}
          {{on 'blur' this.onBlur}}
        />
        {{yield (hash checked=@checked disabled=@disabled onChange=this.onChange)}}
      </BoxItem>
    {{/let}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvChoiceBlocks::Input': typeof BvChoiceBlocksInputComponent;
        'bv-choice-blocks/input': typeof BvChoiceBlocksInputComponent;
    }
}
